import moment from "moment";

const isWithinDay = (input: moment.MomentInput): boolean => {
    const eventDate = moment(input);
    const currentDate = moment();

    return eventDate.diff(currentDate, "days") === 0;
};

const hasPassed = (input: moment.MomentInput, thresholdMinutes?: number): boolean => {
    const eventDate = moment(input);
    const currentDate = moment();

    return (thresholdMinutes ?? 0) < currentDate.diff(eventDate, "minutes");
};

export { isWithinDay, hasPassed };
